import { render, staticRenderFns } from "./CreateDoctorHonorForm.vue?vue&type=template&id=10ff83be&scoped=true"
import script from "./CreateDoctorHonorForm.vue?vue&type=script&lang=js"
export * from "./CreateDoctorHonorForm.vue?vue&type=script&lang=js"
import style0 from "./CreateDoctorHonorForm.vue?vue&type=style&index=0&id=10ff83be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff83be",
  null
  
)

export default component.exports